import React from "react";
import { CrudInformasiTol } from "../../../components";

const InformasiTol = () => {
  return <CrudInformasiTol title="Informasi Tol" type={15} />;
};

export default InformasiTol;
